<div class="container" theme [styleObj]='brandStyleTheme'>

    <div class="row">

        <div class="col-12 col-md-4 msg-container">

            <div class="card">
    
                <div class="card-header">
        
                    <ng-template headerSection></ng-template>
        
                </div>
        
                <div class="card-body">

                    <div class="alert alert-info text-center mb-3">
                        <p class="mb-0">{{customerName | titlecase}}, your bill is due on {{ dueDate | date }} in the amount of {{amountDue | currency}}. Please use the form below to submit your payment:</p>
                    </div>

                    <form [formGroup]="paymentForm" (ngSubmit)="onSubmitPayment(paymentForm.value)">

                        <h6 class="mb-2">Amount:</h6>

                        <div class="d-block my-3">

                            <div class="form-check">
                                <input class="form-check-input" type="radio" name="paymentAmount" id="totalDueAmount" 
                                    value="totalDue" checked (click)="onChangePaymentAmount('totalDue')">
                                <label class="form-check-label" for="totalDueAmount">
                                  Total Due: {{amountDue | currency}}
                                </label>
                              </div>
 
                              <div class="form-check">
                                <input class="form-check-input" type="radio" name="paymentAmount" id="otherAmount" 
                                    value="other" (click)="onChangePaymentAmount('other')">
                                <label class="form-check-label" for="otherAmount">
                                  Other
                                </label>
                              </div>

                            @if (isOtherPaymentAmountShown) {
                                <div class="row">
                                    <div class="col-sm-6 col-12">
                                        <input type="currency" formControlName="otherPaymentAmount" class="form-control" 
                                            id="otherPaymentAmount" placeholder="Enter Amount" />
                                    </div>
                                    @if (!paymentForm.get('otherPaymentAmount')?.valid && paymentForm.get('otherPaymentAmount')?.dirty) {
                                        <div class="alert alert-danger">
                                          Incorrect payment amount
                                        </div>
                                    }
                                </div>
                            }
    
                        </div>

                        <h6 class="mb-2">Payment Date:</h6>

                        <div class="d-block my-3">

                            <div class="form-check">
                                <input class="form-check-input" type="radio" name="paymentDate" id="todayPaymentDate" 
                                    value="today" checked (click)="onChangePaymentDate('today')">
                                <label class="form-check-label" for="todayPaymentDate">
                                  Today: {{ today | date }}
                                </label>
                              </div>

                              <div class="form-check">
                                <input class="form-check-input" type="radio" name="paymentDate" id="dueDatePaymentDate" 
                                    value="dueDate" (click)="onChangePaymentDate('dueDate')">
                                <label class="form-check-label" for="dueDatePaymentDate">
                                  Due Date: {{ dueDate | date }}
                                </label>
                              </div>

                              <div class="form-check">
                                <input class="form-check-input" type="radio" name="paymentDate" id="otherDate" 
                                    value="other"  (click)="onChangePaymentDate('other')">
                                <label class="form-check-label" for="otherDate">
                                  Other
                                </label>
                              </div>

                              @if (isOtherPaymentDateShown) {
                                <div class="row">
                                    <div class="col-sm-6 col-12">
                                        <input type="date" formControlName="otherPaymentDate"
                                        class="form-control" id="otherPaymentDate" placeholder="Enter Payment Date" />
                                    </div>
                                </div>
                            }
                              
                        </div>

                        <h6 class="mb-2">Payment Method:</h6>

                        <div class="d-block my-3">

                            <div class="accordion" id="myAccordion">
                                <div class="accordion-item">
                                  <h2 class="accordion-header" id="headingOne">
                                    <button class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                      CHECKING / SAVINGS <span class="wp-spacer"></span>Your Securely Stored Accounts
                                    </button>
                                  </h2>
                                  <div id="collapseOne" class="accordion-collapse collapse show" aria-labelledby="headingOne" data-parent="#accordion">
                                    <div class="accordion-body">
                                        <select formControlName="bankAccount" class="form-select" (change)="onChangePaymentMethod('checking/savings')">
                                            @for (bankAccount of bankAccounts; track bankAccount) {
                                              <option [value]="bankAccount.id">{{bankAccount.nickName}}</option>
                                            }
                                        </select>                    
                                  </div>
                                </div>
                              </div>
                    
                              <div class="accordion-item">
                                <h2 class="accordion-header" id="headingTwo">
                                  <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                                    DEBIT / CREDIT <span class="wp-spacer"></span>Your Securely Stored Cards
                                  </button>
                                </h2>
                                <div id="collapseTwo" class="accordion-collapse collapse" aria-labelledby="headingTwo" data-parent="#accordion">
                                  <div class="accordion-body">
                                    <select formControlName="card" class="form-select" (change)="onChangePaymentMethod('debit/credit')">
                                        @for (card of cards; track card) {
                                          <option [value]="card.id">{{card.nickName}}</option>
                                        }
                                    </select>                    
                                  </div>
                                </div>
                              </div>
                    
                            </div>

                        </div>                        

                        @if (!isSuccessMessageShown) {
                          <button type="submit" icon="fa fa-check" class="wp-btn wp-btn-submit" title="Pay Now"
                          [disabled]="!paymentForm.valid">Pay Now
                          </button>
                        }

                        @if (isSuccessMessageShown) {
                            <div class="alert alert-success" role="alert">{{successMessage}}</div>
                            <button type="button" icon="fa fa-close" class="wp-btn wp-btn-cancel" 
                                (click)="onClose()" label="Close">Close Window
                            </button>                
                        }  
                        
                        @if (isSpinnerShown) {
                          <div class="text-center">
                            <div class="spinner-border text-primary" role="status">
                              <span class="sr-only">Processing...</span>
                            </div>
                          </div>
                        }
    
                      </form>


                </div>
        
                <div class="card-footer">

                  <div class="row">
                    <div class="col">
                    </div>
                    <div class="col d-md-flex justify-content-md-end">
                      <button type="button" icon="fa fa-check" class="btn btn-link"
                      (click)="onAccountTasksDemo()">Account Tasks
                      </button>
                    </div>
                  </div>


                    <ng-template footerSection></ng-template>
        
                </div>
  
            </div>    
        
        </div>

    </div>

</div>
  
